import {
  faCheckCircle,
  faDownload,
  faHandHoldingUsd,
  faHome,
  faReceipt,
} from '@fortawesome/pro-light-svg-icons'

const generateNavigationItems = (selectedAgencyId: number) => {
  const baseHref = `#/agencies/${selectedAgencyId}/manage`

  return {
    sections: [
      {
        key: 'accounting',
        title: 'ACCOUNTING',
        visible: true,
        items: [
          {
            href: `${baseHref}/accounting/invoices`,
            icon: faReceipt,
            key: 'invoices',
            title: 'Invoices',
            visible: true,
          },
          {
            href: `${baseHref}/accounting/invoices?type=debtor`,
            icon: faReceipt,
            key: 'bills',
            title: 'Bills',
            visible: true,
          },
          {
            href: `${baseHref}/accounting/campaignContributions`,
            icon: faHandHoldingUsd,
            key: 'campaign-contributions',
            title: 'Campaign Contributions',
            visible: true,
          },
          {
            href: `${baseHref}/accounting/orderReconciliation`,
            icon: faCheckCircle,
            key: 'order-reconciliation',
            title: 'Order Reconciliation',
            visible: true,
          },
          {
            href: `${baseHref}/accounting/campaignStatement`,
            icon: faHome,
            key: 'campaign-statement',
            title: 'Campaign Statement',
            visible: true,
          },
          {
            href: `${baseHref}/accounting/invoicesImport`,
            icon: faDownload,
            key: 'import-invoices',
            title: 'Import Invoices',
            visible: true,
          },
        ],
      },
    ],
  }
}

export default generateNavigationItems
